/**
 * 二维码相关接口
 * 文档地址 http://47.110.15.13:8020/pages/viewpage.action?pageId=6291622
 */
const qrcode = {
  // 2.1 生成二维码
  makeQRCode: '/api/QRCodeManagement/MakeQRCode',
  // 2.2 更新二维码信息
  updateQRCodeInfo: '/api/QRCodeManagement/UpdateQRCodeInfo',
  // 2.3 上传图片
  savePic: '/api/QRCodeManagement/SavePic',
  // 2.4、获取二维码详情 返回html数据接口
  getQRCodeDataDetail: '/api/QRCodeManagement/GetQRCodeDataDetail',
  // 2.5、分页查询二维码
  pageQueryQrcodeInfo: '/api/QRCodeManagement/PageQueryQrcodeInfo',
  // 2.6、删除图片
  deletePic: '/api/QRCodeManagement/DeletePic',
  // 2.7、删除二维码
  deleteQRCode: '/api/QRCodeManagement/DeleteQRCode',
  // 2.8、获取二维码文件上传的FolderID
  getUserDocFolderIDByType: '/api/DocManager/GetUserDocFolderIDByType',
  // 2.9 最新编辑二维码信息接口 增加htmlFile参数
  saveAndUpdateQRCodeInfo: '/api/QRCodeManagement/SaveAndUpdateQRCodeInfo',
  // 2.10 获取二维码详情 返回路径
  getQRCodeDetail: '/api/QRCodeManagement/GetQRCodeDetail',
  // 2.10 上传文件
  uploadFile: '/api/DocManager/UploadFile',
  // 获取下载文件的路径
  downloadSharedFiles: '/api/DocManager/DownloadSharedFiles',
  // 获取文件预览地址
  getPreviewUrl: '/api/Doc/GetPreviewUrl',
  // 删除文件
  removeFolderOrFile: '/api/DocManager/RemoveFolderOrFile',
  // 2.5.1添加分类
  addQRCodeType: '/api/QRCodeManagement/AddQRCodeType',
  // 2.5.2更新分类
  updateQRCodeType: '/api/QRCodeManagement/UpdateQRCodeType',
  // 2.5.3获取分类
  getQRCodeTypes: '/api/QRCodeManagement/GetQRCodeTypes',
  // 2.5.4删除分类
  deleteQRCodeType: '/api/QRCodeManagement/DeleteQRCodeType',
  // 获取Viewer引擎类型
  getViewerType: '/api/Doc/GetSupportEngine',
  // 获取二维码详情，不需要token，用于扫码预览的页面
  getQrcodeDetailWithoutToken: '/api/QRCode/GetQRCodeDataDetail',
}

Object.freeze(qrcode)
export default qrcode
